export enum TooExaminationOrder {
    notFocusable = -1,
}
